import { Asterisk } from "lucide-react";

const WORDS = ["Smartphone", "Permuta dell'usato", "Accessori", "Riparazioni", "Audio wireless", "Assistenza"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-5xl font-medium tracking-tight sm:text-7xl ${i % 2 ? "text-outline" : "text-fg"}`}>{w}</span>
        <Asterisk className="h-8 w-8 text-[var(--volt)] sm:h-10 sm:w-10" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="marquee-wrap tone-dark relative overflow-hidden bg-[var(--ink)] py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
